import { useQuery } from '@tanstack/react-query';

const handleError = (error) => {
  if (error?.message === 'Request Aborted') return;
  if (!error?.code || (error.code >= 500 && error.code <= 599)) return { error: true };
  else if (error.code === 403) return { error: true, unauthorized: true };
  else if (error.code === 404) return { error: true, notFound: true };
  else return { error: true };
};

export const useRouteQueryResponse = (props = {}) => {
  const { queryKey = [], queryFn, enabled = true, onError } = props;

  const { data } = useQuery({
    queryKey,
    queryFn: async () => {
      try {
        const res = await queryFn();
        return res;
      } catch (error) {
        handleError(error);
        onError && onError(error);
      }
    },
    enabled,
  });

  return {
    data,
    error: data?.error,
    notFound: data?.notFound,
    unauthorized: data?.unauthorized,
    result: data?.error ? {} : data,
  };
};
